const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)

const DEBUG_MODE = window.location.href.indexOf('localhost') > -1 || (urlParams.has('debug') && urlParams.get('debug'))


export { DEBUG_MODE }
